import React from 'react';
import './ChoseTypePerson.scss';

const ChoseTypePerson = ({sendData, setSendData}) => {

  return (
    <div className="radio-buttons-container">
      <div className="radio-button">
        <label htmlFor="radio2" className="radio-button__label" style={{padding: "0", fontWeight: "500"}}>
          نوع شخص :
        </label>
      </div>
      <div className="radio-button">
        <input name="radio-group"
               id="radio2"
               className="radio-button__input"
               type="radio"
               checked={sendData?.personType === "real"}
               onChange={() => setSendData({...sendData, personType: "real", nationalId: ""})}/>
        <label htmlFor="radio2" className="radio-button__label">
          <span className="radio-button__custom"></span>
          حقیقی شخصی
        </label>
      </div>
      <div className="radio-button">
        <input name="radio-group"
               id="radio1" className="radio-button__input"
               type="radio"
               checked={sendData?.personType === "real-organize"}
               onChange={() => setSendData({...sendData, personType: "real-organize", nationalId: ""})}/>
        <label htmlFor="radio1" className="radio-button__label">
          <span className="radio-button__custom"></span>
          حقیقی سازمانی
        </label>
      </div>
      <div className="radio-button">
        <input name="radio-group"
               id="radio3"
               className="radio-button__input"
               type="radio"
               checked={sendData?.personType === "legal"}
               onChange={() => setSendData({...sendData, personType: "legal", nationalId: ""})}/>
        <label htmlFor="radio3" className="radio-button__label">
          <span className="radio-button__custom"></span>
          حقوقی
        </label>
      </div>
    </div>
  );
};

export default ChoseTypePerson;